import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const backendURL = `${AWS_API_URL}/user/rss-feeds`;

export async function addRSSFeedAPI(url) {
  return postRequest(backendURL, { url }, await authorize());
}
